import { Button, Popover } from 'antd';
import React, { Fragment, useEffect, useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretDown, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import PropTypes from 'prop-types';
import H3Text from '@Uilib/h3Text';
import H3Button, { defaultButtonTypes } from '@Uilib/h3Button';
import SelectDepartment from '@Components/Common/SelectDepartment';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import DepartmentActions from '@Actions/departmentActions';
import mrpV2Actions from '@Actions/production/mrpV2Actions';

const content = (
  <div style={{ width: '400px', padding: '0.5px', margin: '0px' }}>
    <H3Text text="By default, all departments are included for consideration. However, choosing specific departments will impact the availability of required stock materials." />
  </div>
);

const UpdateMrpDepartment = ({
  openPopover, updateMrpV2Loading, openPopoverChange, mrp, updateMrpV2, setCall, call, departments,
}) => {
  const [selectedDepartment, setSelectedDepartment] = useState([]);
  useEffect(() => {
    if (mrp?.tenant_department_ids) {
      setSelectedDepartment(mrp?.tenant_department_ids?.split(',').map((tenantDepartmentId) => Number(tenantDepartmentId)));
    }
  }, []);

  const getButtonLabel = () => {
    const data = departments?.data?.result?.departments?.filter((department) => selectedDepartment.includes(department?.tenant_department_id));
    let response = '';
    if (data?.length > 0) response += `${data?.length > 1 ? `${data?.[0]?.department_info?.department_name} (+${data?.length - 1})` : data?.[0]?.department_info?.department_name}`;
    if (!data?.length) response = 'All Departments';
    return (
      <Fragment>
        {response}
        &nbsp;
        <FontAwesomeIcon icon={faCaretDown} />
      </Fragment>
    );
  };
  return (
    <React.Fragment>
      <Popover
        placement="bottomRight"
        trigger="click"
        title={(
          <div style={{ width: '280px', zIndex: -1 }}>
            Select Departments for this MRP
            &nbsp;
            <Popover content={content} placement="bottom">
              <FontAwesomeIcon icon={faInfoCircle} className="info-icon" color="#008FFB" />
            </Popover>
          </div>
        )}
        open={openPopover}
        onOpenChange={(visible) => {
          if (visible) openPopoverChange();
          else {
            openPopoverChange();
            updateMrpV2({
              mrp_id: mrp?.mrp_id,
              tenant_department_ids: selectedDepartment.length > 0 ? selectedDepartment.join(',') : null,
            }, () => {
              setCall(!call);
            });
          }
        }}
        content={(
          <React.Fragment>
              <SelectDepartment
                title="Select Department"
                hideTitle
                selectedDepartment={selectedDepartment}
                noDropdownAlign
                onChange={(value) => {
                  setSelectedDepartment(value);
                }}
                getPopupContainer={(triggerNode) => triggerNode.parentNode}
                tenentLevelDepartment
                placeholderText="Select Department For Stock Availability"
                isMultiple
                customStyle={{
                  borderRadius: '4px',
                  width: '300px',
                  fontSize: '13px',
                  marginRight: '10px',
                  padding: '2px ',
                  zIndex: 1001,
                }}
                bordered
                showSearch
                tenantId={mrp?.tenant_id}
                className="filter__button"
              />
            <div style={{ marginTop: '10px', paddingLeft: '2px',}}>
              <Button
                type="primary"
                onClick={() => updateMrpV2({
                  mrp_id: mrp?.mrp_id,
                  tenant_department_ids: selectedDepartment.length > 0 ? selectedDepartment.join(',') : null,
                }, () => {
                  setCall(!call);
                  openPopoverChange();
                })}
                loading={updateMrpV2Loading}
                disabled={updateMrpV2Loading}
                size="small"
              >
                Update
              </Button>
            </div>
          </React.Fragment>
        )}
        getPopupContainer={(triggerNode) => triggerNode.parentNode}
      >
        <div
          className="report-header__action-btn"
        >
          <H3Text
            text={getButtonLabel()}
            className="action-button"
          />
        </div>

      </Popover>
    </React.Fragment>
  );
};

const mapStateToProps = ({ DepartmentReducers, UserReducers, MrpV2Reducers }) => ({
  departments: DepartmentReducers.departments,
  user: UserReducers.user,
  updateMrpV2Loading: MrpV2Reducers?.updateMrpV2Loading,
});

const mapDispatchToProps = (dispatch) => ({
  updateMrpV2: (payload, callback) => dispatch(mrpV2Actions.updateMrpV2(payload, callback)),
});

UpdateMrpDepartment.propTypes = {
  openPopover: PropTypes.bool,
  mrp: PropTypes.array,
  user: PropTypes.object,
  openPopoverChange: PropTypes.func,
  updateMrpV2: PropTypes.func,
  setCall: PropTypes.func,
  call: PropTypes.any,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(UpdateMrpDepartment));
